module.exports = __webpack_public_path__ + "img/logo.d0e6147.png";